module.exports = __webpack_public_path__ + "71663b5fd7ed7fdad0c5303f3938bd12.jpg";